module.exports = __webpack_public_path__ + "img/spectrum-article.f74609b7.jpg";